"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = require("../icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tooltip = function Tooltip(_ref) {
  var content = _ref.content,
      icon = _ref.icon,
      className = _ref.className,
      children = _ref.children;

  var prefixCls = "tooltip";

  var componentCls = (0, _classnames2.default)(prefixCls, className);

  var contentWrapperCls = prefixCls + "__content-wrapper";
  var contentCls = prefixCls + "__content";
  var iconCls = prefixCls + "__icon";

  var parent = icon ? _react2.default.createElement(
    "div",
    { className: iconCls },
    _react2.default.createElement(_icons.InfoOutlineIcon, null)
  ) : _react2.default.createElement(
    "div",
    { className: "" },
    children
  );

  return _react2.default.createElement(
    "div",
    { className: componentCls },
    parent,
    _react2.default.createElement(
      "div",
      { className: contentWrapperCls },
      _react2.default.createElement(
        "div",
        { className: contentCls },
        content
      )
    )
  );
};

Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  content: _propTypes2.default.node,
  className: _propTypes2.default.string,
  children: _propTypes2.default.array,
  icon: _propTypes2.default.bool
} : {};

exports.default = Tooltip;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/tooltip/tooltip.js
// module id = 1424
// module chunks = 249